import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'

type Params = {
  customerId: string
}

type CommercialReference = {
  fullName: string
  clientSince: string
  majorBuyValue: number
  creditLimit: number
  paymentCondition: string
}

type Response = Promise<{
  data: CommercialReference[]
  total: number
}>

const loadOrderCommercialReferences = (data: Params): Response => {
  return axios.get(`/orders/customers/${data.customerId}/commercial-references`)
}

export function useLoadOrderCommercialReferences(query: Params) {
  return useQuery(
    ['orderCommercialReferences', query],
    () => loadOrderCommercialReferences(query),
    {
      enabled: !!query.customerId,
      onError: () =>
        toast.error(
          'Não foi possível carregar as referências comerciais do cliente!',
          {
            toastId: 'loadOrderCommercialReferences'
          }
        )
    }
  )
}
